import { isFunction, isNill } from './asserts';
function mergeRefs(refs) {
    return (value) => {
        refs.forEach((ref) => {
            if (isFunction(ref)) {
                ref(value);
            }
            else if (!isNill(ref)) {
                ;
                ref.current = value;
            }
        });
    };
}
export default mergeRefs;
//# sourceMappingURL=merge-refs.js.map